import dayjs, { Dayjs } from 'dayjs';

export const maxTime = (time: Dayjs): Dayjs => {
    const zero = dayjs(new Date().setHours(0, 0, 0, 0));
    return dayjs(time).isSame(zero) ? time : dayjs(time).add(-1, 'minutes');
};
